import type { HTMLAttributes, ReactNode } from 'react'
import clsx from 'clsx'
import styles from './Badge.module.scss'

export type BadgeTone = 'gray' | 'blue' | 'purple' | 'green' | 'amber' | 'red' | 'pink' | 'teal' | 'brand' | 'dark'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
  size?: 'sm' | 'md'
  dot?: boolean
  outline?: boolean
  icon?: ReactNode
}

export function Badge({ tone = 'gray', size = 'md', dot, outline, icon, className, children, ...rest }: BadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], size === 'sm' && styles.sm, outline && styles.outline, className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {icon}
      {children}
    </span>
  )
}

/** Small numeric counter (sidebar badges, tab counts). */
export function CountBadge({ value, className }: { value: number | string; className?: string }) {
  return <span className={clsx(styles.count, className)}>{value}</span>
}
